export default {
    methods: {
        toastAndReload(payload, id = null, fallback = {}) {
            this.loading = false;
            this.errors = {};
            this.$toastr.s('', this.$resolveMessage(payload, fallback));
            if (id) this.$hub.$emit(`reload-${id}`)
        },
        toastSuccess(payload, fallback = {}) {
            this.$toastr.s('', this.$resolveMessage(payload, fallback));
        },
        toastError(payload, fallback = {key: 'failed_response'}) {
            this.$toastr.e('', this.$resolveError(payload, fallback));
        },
        toastInfo(payload, fallback = {}) {
            this.$toastr.i('', this.$resolveMessage(payload, fallback));
        },
        toastException(data, fallback = {key: 'failed_response'}) {
            this.loading = false;
            this.toastError(data, fallback);
        },
        generateModalTitle(subject) {
            return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
        },
        scrollToTop(afterRender = true) {
            const handler = () => window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });

            if (afterRender) {
                setTimeout(() => handler())
            } else {
                handler();
            }

        }
    }
}
